// extracted by mini-css-extract-plugin
var _1 = "SearchViewHeader-module__activeTab--MpXlL";
var _2 = "SearchViewHeader-module__animateUploadProgressBarWidth--shgny";
var _3 = "SearchViewHeader-module__animatedBackground--tujYr";
var _4 = "SearchViewHeader-module__headerSection--go0ja";
var _5 = "SearchViewHeader-module__tab--ZHw4S";
var _6 = "SearchViewHeader-module__verticalHeaderSection--BZIpL";
export { _1 as "activeTab", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "headerSection", _5 as "tab", _6 as "verticalHeaderSection" }
